module.exports = __webpack_public_path__ + "media/custom/images/img6-7a150d45e3aaa3440ca4de930fa6ff8e.png";